import './App.css';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { WebModeProvider } from './context/WebModeContext';
import About from './pages/About';
import AboutWebThree from './pages/AboutWebThree';
import Contact from './pages/Contact';
import ContactWebThree from './pages/ContactWebThree';
import Work from './pages/Work';
import WorkWebThree from './pages/WorkWebThree';
import MyStory from './pages/MyStory';
import Homepage from './pages/Homepage';
import HomepageWebThree from './pages/HomepageWebThree';
import { useWebMode } from './context/WebModeContext';

// Create a wrapper component for the homepage that conditionally renders based on Web 3 mode
const HomepageWrapper = () => {
  const { isWeb3Mode } = useWebMode();
  return isWeb3Mode ? <HomepageWebThree /> : <Homepage />;
};

// Create a wrapper component for the work page that conditionally renders based on Web 3 mode
const WorkWrapper = () => {
  const { isWeb3Mode } = useWebMode();
  return isWeb3Mode ? <WorkWebThree /> : <Work />;
};

// Create a wrapper component for the about page that conditionally renders based on Web 3 mode
const AboutWrapper = () => {
  const { isWeb3Mode } = useWebMode();
  return isWeb3Mode ? <AboutWebThree /> : <About />;
};

// Create a wrapper component for the contact page that conditionally renders based on Web 3 mode
const ContactWrapper = () => {
  const { isWeb3Mode } = useWebMode();
  return isWeb3Mode ? <ContactWebThree /> : <Contact />;
};

function App() {
  return (
    <div className="App">
      <WebModeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomepageWrapper />} />
            <Route path="/about" element={<AboutWrapper />} />
            <Route path="/work" element={<WorkWrapper />} />
            <Route path="/contact" element={<ContactWrapper />} />
            <Route path="/mystory" element={<MyStory />} />
          </Routes>
        </BrowserRouter>
      </WebModeProvider>
    </div>
  );
}

export default App;
